<script setup>
const config = useRuntimeConfig();
const props = defineProps({
  text: Object,
  textColor: String,
  textPosition: String,
  video: String,
  button: Object,
});
</script>

<template>
  <div
    class="flex flex-wrap items-center mb-xl last:mb-0 px-md lg:px-lg xl:px-xl"
    :class="
      textPosition === 'left'
        ? 'flex-col-reverse md:flex-row'
        : 'flex-col-reverse md:flex-row-reverse'
    "
  >
    <div class="w-full md:w-1/2">
      <div
        v-html="text"
        class="prose"
        :class="textColor === 'dark' ? 'prose--black' : ''"
      ></div>
      <div v-if="button.text && button.url" :class="text ? 'mt-xl' : ''">
        <Button
          type="link"
          :href="
            button.type === 'linkInternal'
              ? config.public.appBaseUrl + button.url
              : button.url
          "
          :text="button.text"
          :target="button.target"
          :icon="true"
          :aria-label="button.ariaLabel"
          :color="button.color"
          icon-position="right"
        />
      </div>
    </div>
    <div
      class="w-full md:w-1/2 mb-lg md:mb-0"
      :class="
        textPosition === 'left'
          ? 'md:pl-lg lg:pl-xl xl:pl-2xl'
          : 'md:pr-lg lg:pr-xl xl:pr-2xl'
      "
    >
      <video v-if="video" autoplay loop muted playsinline class="">
        <source :src="video" type="video/mp4" />
      </video>
    </div>
  </div>
</template>

<style></style>
